var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfettiImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 182,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.992 61.16 22.933 116.05c-4.34 4.25-11.305 4.177-15.555-.164a11 11 0 0 1-3.04-9.182l10.306-75.552c4.684 6.677 14.564 13.49 29.639 20.441 15.075 6.95 26.644 10.14 34.71 9.565Z",
    id: "a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h223v182H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60 17.32)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#EEF3F5",
    cx: 51.108,
    cy: 78.584,
    rx: 51.108,
    ry: 51
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#DBAA0A",
    transform: "rotate(34 62.52 60.75)",
    cx: 62.52,
    cy: 60.75,
    rx: 35.5,
    ry: 6
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(9 -38.048 153.207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.724.759c10.681 18.965 12.51 35.406 5.487 49.325",
    stroke: "#FFDDDC",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.033 57.349C68.89 42.583 86.85 39.21 105.908 47.232",
    stroke: "#8DD9FF",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFEC9C",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.473 40.594C16.078 51.75 25.047 59.655 36.38 64.308c11.333 4.652 24.032 7.033 38.099 7.143L63.958 82.866c-13.237.359-24.213-1.454-32.929-5.438-8.715-3.985-16.826-10.469-24.332-19.453L3.771 75.248c5.104 9.162 11.815 15.049 20.132 17.66 8.318 2.61 17.43 3.601 27.338 2.973l-17.39 13.503c-7.167-.086-13.023-1.019-17.565-2.798-4.542-1.78-8.714-6.339-12.515-13.679",
    stroke: "#FFA5A3",
    strokeWidth: 3,
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3D3D3D",
    mask: "url(#b)",
    d: "M12.109 36.7 3.771 94.16"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFEBEA",
    transform: "rotate(9 6.496 24.982)",
    cx: 6.496,
    cy: 24.982,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E4F6FF",
    transform: "rotate(9 30.036 11.554)",
    cx: 30.036,
    cy: 11.554,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFEBEA",
    transform: "rotate(9 100.236 31.723)",
    cx: 100.236,
    cy: 31.723,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C9F1B4",
    transform: "rotate(9 107.161 49.941)",
    cx: 107.161,
    cy: 49.941,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E4F6FF",
    transform: "rotate(9 109.987 78.828)",
    cx: 109.987,
    cy: 78.828,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#403F4B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m62.061 40.144 8.498-2.14-4.746-7.633 8.572-2.332-4.821-7.44 8.883-3.143-4.925-7.17 8.724-2.727L77.471 0M66.975 59.44l5.685 1.616-.198-6.059 5.792 1.529-.306-5.972 6.248 1.16-.459-5.847 6.015 1.348-.24-6.025"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#403F4B",
    strokeWidth: 2,
    cx: 9.5,
    cy: 52.18,
    r: 6.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfettiImage);
export default __webpack_public_path__ + "static/media/confetti-image.c714e2ec.svg";
export { ForwardRef as ReactComponent };